<template>
  <div class="app-grid-footer app-bar">
    <div class="app-grid-footer__summary"><slot name="summary" /></div>
    <div v-if="showPager" class="app-grid-footer__pager">
      <app-select
        class="app-grid-footer__size"
        :value="pageSize"
        :items="sizeItems"
        :menu-width="160"
        @input="setPageSize"
      />
      <span v-if="totalCount > 0" class="app-grid-footer__range">{{ rangeText }}</span>
      <div class="app-pager" role="group" aria-label="Seiten blättern">
        <app-icon-button
          class="app-ib--compound app-pager__btn app-pager__prev"
          icon="chevL"
          label="Vorherige Seite"
          :boxed="false"
          :disabled="pageIndex <= 0"
          @click="goTo(pageIndex - 1)"
        />
        <app-icon-button
          class="app-ib--compound app-pager__btn app-pager__next"
          icon="chevR"
          label="Nächste Seite"
          :boxed="false"
          :disabled="pageIndex >= pageCount - 1"
          @click="goTo(pageIndex + 1)"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Fußleiste unter einem Grid (Spezifikation 2.10, gen_r3.py:994–1003): links Slot summary (Werte als <strong>,
// Trenner <span class="app-sep" aria-hidden="true">·</span>), rechts „30 pro Seite“, „1–30 von 4.578“ und Blättern.
// Die Seite ruft in @content-ready update(e.component) auf; die Bedienung ruft grid.pageIndex(n)/grid.pageSize(n).
// Den DX-Pager der Seite ausblenden (<dx-pager :visible="false" />), dx-paging bleibt.
// pagerAlways=false (Exporte): Seitenwahl und Blättern nur bei mehr als einer Seite.
import AppIconButton from './AppIconButton.vue';
import AppSelect from './AppSelect.vue';
import { formatNumber } from '../../utils/format';

export default {
  name: 'AppGridFooter',
  components: { AppIconButton, AppSelect },
  props: {
    pageSizes: { type: Array, default: () => [5, 10, 30, 50, 100] },
    pagerAlways: { type: Boolean, default: true }
  },
  data() {
    return {
      pageIndex: 0,
      pageCount: 0,
      pageSize: null,
      totalCount: 0
    };
  },
  computed: {
    sizeItems() {
      const sizes = this.pageSizes.slice();
      if (this.pageSize && sizes.indexOf(this.pageSize) === -1) {
        sizes.push(this.pageSize);
        sizes.sort((a, b) => a - b);
      }
      return sizes.map(n => ({ value: n, text: n + ' pro Seite' }));
    },
    showPager() {
      return this.pagerAlways || this.pageCount > 1;
    },
    rangeText() {
      const size = this.pageSize || this.totalCount;
      const start = this.pageIndex * size + 1;
      const end = Math.min((this.pageIndex + 1) * size, this.totalCount);
      return formatNumber(start) + '–' + formatNumber(end) + ' von ' + formatNumber(this.totalCount);
    }
  },
  created() {
    // DX-Instanz nicht reaktiv halten
    this.grid = null;
  },
  methods: {
    update(grid) {
      this.grid = grid || null;
      if (!grid) {
        this.pageIndex = 0;
        this.pageCount = 0;
        this.totalCount = 0;
        return;
      }
      const index = Number(grid.pageIndex());
      const count = Number(grid.pageCount());
      const size = Number(grid.pageSize());
      const total = Number(grid.totalCount());
      this.pageIndex = index > 0 ? index : 0;
      this.pageCount = count > 0 ? count : 0;
      this.pageSize = size > 0 ? size : this.pageSize;
      this.totalCount = total > 0 ? total : 0;
    },
    goTo(index) {
      if (!this.grid || index < 0 || (this.pageCount && index > this.pageCount - 1)) {
        return;
      }
      this.pageIndex = index;
      this.grid.pageIndex(index);
    },
    setPageSize(size) {
      if (!this.grid || !size) {
        return;
      }
      this.pageSize = size;
      this.grid.pageSize(size);
    }
  }
};
</script>
